import { get } from 'lodash'

export const headers = (intl = {}) => [
  intl.formatMessage({
    id: 'table.id'
  }),
  intl.formatMessage({
    id: 'table.journey_category'
  }),
  intl.formatMessage({
    id: 'table.journey_activity'
  }),
  intl.formatMessage({
    id: 'table.journey_type'
  }),
  intl.formatMessage({
    id: 'table.award_level'
  }),
  intl.formatMessage({
    id: 'table.award_unit'
  }),
  intl.formatMessage({
    id: 'table.start_date'
  }),
  intl.formatMessage({
    id: 'table.end_date'
  }),
  intl.formatMessage({
    id: 'table.created_by'
  }),
  intl.formatMessage({
    id: 'table.participants'
  })
]

export const line = (data = []) =>
  data.map(item => {
    return {
      line: [
        item.globalId || item.id,
        get(item, 'ajEventCategory.translationText'),
        get(item, 'activityCategory.translatedName'),
        get(item, 'activityCategory.parent.translatedName'),
        get(item, 'awardLevel.translationText'),
        get(item, 'organization.name'),
        get(item, 'startDate'),
        get(item, 'endDate'),
        `${get(item, 'createdByPerson.firstName')} ${get(
          item,
          'createdByPerson.lastName'
        )}`,
        item.ajParticipantEvents.length
      ]
    }
  })
